export const availableLanguageConst= [
    {code:"fr", description:"Français", language:"fr-FR"},
    {code:"en", description:"English", language:"en-US"},
    {code:"de", description:"German", language:"de-DE"},
    {code:"nl", description:"Dutch", language:"nl-NL"}
]
